// removed by extract-text-webpack-plugin
module.exports = {"image":"_2WIlTwMFfHrfeZt_sO1bUa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Image/Image.module.scss
// module id = 778
// module chunks = 0